import { render, staticRenderFns } from "./Posting Inbox.vue?vue&type=template&id=7d1ceb12&"
import script from "./Posting Inbox.vue?vue&type=script&lang=js&"
export * from "./Posting Inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports